/*
  NordiskPuls NO - "har kunden taget imod gaven?" og "har hun sagt nei takk?"
  =================================================================
  Eet sted at laese og saette begge dele, fordi baade gavemotoren og
  gave-popup'en har brug for dem. Skal indlaeses FOER dem begge.

  TO SPOERGSMAAL, IKKE ET
  Da hun skrev sin mail, betoed eet flag begge dele: "hun har RET til
  gaven" og "vis ikke popup'en igen". De to ting har ikke samme levetid.
    RETTEN skal holde. Ellers mister hun gaven hun lige har sagt ja til,
    naeste gang hun aabner siden - motoren skal blive ved med at lagge
    dekslet i kurven naar der er en Pulsen Pro i den.
    AFBRYDELSEN skal IKKE holde. Hun gav sin mail, men koebte ikke. Saa
    skal hun mindes om gaven naeste gang hun kigger forbi.
  Derfor: har() er permanent (cookie + localStorage) og laeses af
  motoren. svaretNu() lever kun i denne fane og laeses af popup'en.

  HVORFOR BAADE COOKIE OG localStorage
  Safari (ITP) kapper cookies sat fra JavaScript til 7 dage, uanset hvad
  vi skriver i expires. En kunde der har taget imod gaven ville altsaa
  miste retten til den ugen efter. localStorage rammes ikke af den regel.
  Vi skriver begge steder og accepterer det foerste der svarer ja.
*/
(function () {
  'use strict';

  var NOEGLE = 'np_gave_mail';
  var SVARET = 'np_gave_svaret';   // kun dette besoeg

  function fraCookie() {
    return document.cookie.split('; ').some(function (c) {
      return c.indexOf(NOEGLE + '=1') === 0;
    });
  }

  function fraLager() {
    try { return localStorage.getItem(NOEGLE) === '1'; } catch (e) { return false; }
  }

  window.npGaveFlag = {
    // RETTEN til gaven. Permanent. Laeses af np-gavemotor.js.
    har: function () { return fraLager() || fraCookie(); },

    // Har hun svaret i DETTE besoeg? Laeses af np-gavepopup.js, saa
    // popup'en ikke kommer igen paa samme sidevisning - men er tilbage
    // naeste gang hun aabner siden, hvis hun ikke har koebt.
    svaretNu: function () {
      try { return sessionStorage.getItem(SVARET) === '1'; } catch (e) { return false; }
    },

    gem: function () {
      var d = new Date(); d.setDate(d.getDate() + 180);
      document.cookie = NOEGLE + '=1; path=/; expires=' + d.toUTCString() + '; SameSite=Lax';
      try { localStorage.setItem(NOEGLE, '1'); } catch (e) {}
      try { sessionStorage.setItem(SVARET, '1'); } catch (e) {}
      /* Hun sidder lige nu og BEDER om gaven. Saa maa et gammelt
         "nei takk" - eller en gave hun tog ud af kurven i sidste maaned -
         ikke staa i vejen. Uden det her ville popup'en sige "gaven er
         laast op", og motoren ville alligevel ikke lagge den i. */
      rydAlleAfvist();
    },

    // Kun til test
    ryd: function () {
      document.cookie = NOEGLE + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
      try { localStorage.removeItem(NOEGLE); } catch (e) {}
      try { sessionStorage.removeItem(SVARET); } catch (e) {}
    }
  };

  /* ---------- "Nei takk" ----------
     2 timer. Langt nok til at hun ikke bliver afbrudt igen i det samme
     indkoebsaerinde, kort nok til at et besoeg samme aften eller naeste
     dag moeder tilbuddet paa ny.

     Den flydende gave-knap staar der uanset hvad (se np-gavepopup.js) -
     det er kun AFBRYDELSEN der holder pause, ikke adgangen til gaven.
  */

  var AFVIST = 'np_gave_afvist_';
  var AFVIST_MS = 2 * 60 * 60 * 1000;             // "Nei takk" i popup'en
  var FJERNET_MS = 30 * 24 * 60 * 60 * 1000;      // fjernet fra kurven

  /* TO NEJ'ER MED HVER SIN VAEGT
     "Nei takk" i popup'en betyder "ikke nu" - hun har ikke set gaven endnu
     og kan sagtens skifte mening samme aften. 2 timer.
     At fjerne gaven fra kurven betyder noget andet: hun HAR set den,
     hun har den, og hun tager den aktivt ud igen. Kommer den tilbage i
     morgen, er det os der ikke lytter. 30 dage.
     Begge kan fortrydes: skriver hun sin mail i popup'en igen, ryddes
     alle nej'er i gem() ovenfor. */

  window.npGaveAfvist = {
    MS_NEI_TAKK: AFVIST_MS,
    MS_FJERNET: FJERNET_MS,

    er: function (udloeser) {
      try {
        return parseInt(localStorage.getItem(AFVIST + udloeser) || '0', 10) > Date.now();
      } catch (e) { return false; }
    },
    saet: function (udloeser, ms) {
      try {
        localStorage.setItem(AFVIST + udloeser, String(Date.now() + (ms || AFVIST_MS)));
      } catch (e) {}
    },
    ryd: function (udloeser) {
      try { localStorage.removeItem(AFVIST + udloeser); } catch (e) {}
    },
    rydAlle: rydAlleAfvist
  };

  // Baglaens gennem listen: removeItem flytter de foelgende indeks ned.
  // Funktionsdeklaration, ikke et udtryk - saa den er hejst og kan kaldes
  // fra gem() laengere oppe i filen.
  function rydAlleAfvist() {
    try {
      for (var i = localStorage.length - 1; i >= 0; i--) {
        var k = localStorage.key(i);
        if (k && k.indexOf(AFVIST) === 0) localStorage.removeItem(k);
      }
    } catch (e) {}
  }
})();
